// import {post} from '@/util/utils';
import axios from 'axios';
// function fetchLayoutData(id) {
// 	return get('index.php?s=/designer/info.html&id=' + id);
// }

var appKey= "060e684879a0fea6"
var sign="MTJmMTZjMmI5MTg1YmNkNWNkY2Y2MzQ0NmNiNTgxNzRiNjA3NzMwOWE0YTI1Zjk0Nzc1YWNhZWZmNDk0ODM4YQ=="


function fetchLayoutData(id) {
	var data={
		"appKey": appKey,
		"sign": sign,
		"worksheetId": "69d8ba3bd222d2f09a86b851",
		"rowId": id,
		"getSystemControl":false,
	}
	var headers = {
		'Content-Type': 'application/json'
	}
	var response=axios.post('/api/v2/open/worksheet/getRowByIdPost',data,{headers})

	return response;
}

function saveLayoutData(id, title, raw) {
	var data={
		"appKey": appKey,
		"sign": sign,
		"worksheetId": "69d8ba3bd222d2f09a86b851",
		"rowId": id,
		"getSystemControl":false,
		"controls":[
			{
			"controlId":"workshop",
			"value":title
			},{
				"controlId":"raw",
				"value":raw
				}]
	}
	var headers = {
		'Content-Type': 'application/json'
	}
	return axios.post('/api/v2/open/worksheet/editRow',data,{headers});
}

export {fetchLayoutData, saveLayoutData};
